
import { Component, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageBase, T4RentalObjectService } from 't4core';
@Component({
  styleUrls: ['./TypeCategories.css'],
  selector: 'TypeCategories',
  templateUrl: './TypeCategories.html',
})
export class TypeCategoriesComponent extends PageBase {
   
  constructor(el: ElementRef, private route: ActivatedRoute, private svcObject: T4RentalObjectService) {
      super(el, "Settings");
    }
}
